<!-- La marca es la de la empresa (su logo, o su nombre si no tiene): SoftRent solo va en el pie. -->
<ng-template #marca>
  <div class="og__marca">
    @if (logo.hasCustomLogo()) {
      <span class="og__logo"><img [src]="logo.logoUrl()" [alt]="empresa()" /></span>
    } @else if (empresa()) {
      <span class="og__empresa">{{ empresa() }}</span>
    }
    <span class="og__tablet">Taller · {{ cuenta() }}</span>
  </div>
</ng-template>

@if (pantalla(); as p) {
  <div #raiz class="og" role="dialog" aria-modal="true" aria-labelledby="og-titulo" [attr.data-pantalla]="p">
    @switch (p) {
      @case ('entrar') {
        <div class="og__izq">
          <ng-container *ngTemplateOutlet="marca" />
          @if (porInactividad() && estado() !== 'bloqueada' && estado() !== 'sin-conexion') {
            <h1 id="og-titulo" class="og__h1">Pasó un rato sin usar la tablet</h1>
            <p class="og__sub">Pon tu PIN para seguir.</p>
          } @else if (estado() === 'bloqueada') {
            <h1 id="og-titulo" class="og__h1">Tablet bloqueada</h1>
          } @else if (estado() === 'sin-conexion') {
            <h1 id="og-titulo" class="og__h1">Sin conexión</h1>
          } @else {
            <h1 id="og-titulo" class="og__h1">Pon tu PIN</h1>
            <p class="og__sub">Son 4 números. La primera vez, usa el PIN que te dio administración.</p>
          }
          @if (estado() === 'bloqueada') {
            <div class="og__cuenta" role="timer" aria-live="off">{{ cuentaRegresiva() }}</div>
          } @else {
            <sr-pin-dots [llenos]="llenos()" [estado]="estadoPuntos()" />
          }
          <div class="og__mensaje" aria-live="polite">
            @switch (estado()) {
              @case ('validando') {
                <p class="og__msg og__msg--nt"><lucide-angular [img]="icons.Loader" [size]="24" /><span>Revisando tu PIN…</span></p>
              }
              @case ('error') {
                <p class="og__msg og__msg--er" role="alert"><lucide-angular [img]="icons.CircleX" [size]="24" /><span>{{ textoIncorrecto() }}</span></p>
              }
              @case ('fallo') {
                <p class="og__msg og__msg--er" role="alert"><lucide-angular [img]="icons.CircleX" [size]="24" /><span>No pudimos revisar tu PIN. Prueba otra vez.</span></p>
              }
              @case ('bloqueada') {
                <p class="og__msg og__msg--er" role="alert"><lucide-angular [img]="icons.Lock" [size]="24" /><span>Demasiados intentos. Pídele a administración que la desbloquee, o espera {{ minutos() }} min.</span></p>
              }
              @case ('sin-conexion') {
                <div class="og__caja og__caja--aviso" role="alert">
                  <lucide-angular [img]="icons.WifiOff" [size]="22" />
                  <span><b>Esta tablet necesita señal para reconocerte.</b> Conéctate e inténtalo de nuevo.</span>
                </div>
              }
            }
          </div>
        </div>
        <div class="og__der">
          <sr-pin-keypad [deshabilitado]="teclasApagadas()" [activa]="teclaActiva()" (digito)="poner($event)" (borrar)="borrar()" />
        </div>
      }

      @case ('confirmar') {
        <div class="og__centro">
          <ng-container *ngTemplateOutlet="marca" />
          <div class="og__avatar" aria-hidden="true">{{ iniciales() }}</div>
          <p class="og__sub og__sub--hola">Hola,</p>
          <h1 id="og-titulo" class="og__nombre">{{ nombre() }}</h1>
          <span class="og__cargo">{{ cargo() }}</span>
        </div>
        <div class="og__der og__der--col">
          <div class="og__acciones">
            <button type="button" class="og__btn og__btn--pri" (click)="soyYo()">
              <lucide-angular [img]="icons.Check" [size]="26" />Soy yo
            </button>
            <button type="button" class="og__btn og__btn--sec" (click)="noSoyYo()">
              <lucide-angular [img]="icons.Undo2" [size]="26" />No soy yo
            </button>
          </div>
          @if (sigueEnOrden()) {
            <p class="og__tip og__tip--mute"><lucide-angular [img]="icons.CornerDownRight" [size]="20" />Sigues en esta orden de trabajo</p>
          }
        </div>
      }

      @case ('elegir') {
        <div class="og__izq">
          <ng-container *ngTemplateOutlet="marca" />
          <div class="og__fila">
            <span class="og__paso">Paso {{ paso() }} de 2</span>
            <span class="og__etiqueta">Primera vez</span>
          </div>
          <h1 id="og-titulo" class="og__h1">{{ paso() === 1 ? 'Elige tu PIN' : 'Repite tu PIN' }}</h1>
          <p class="og__sub">{{ paso() === 1 ? 'Reemplaza al que te dio administración. Lo vas a usar siempre.' : 'Tecléalo otra vez para confirmar.' }}</p>
          <sr-pin-dots [llenos]="llenos()" [estado]="estadoPuntos()" />
          <div class="og__mensaje" aria-live="polite">
            @switch (errorElegir()) {
              @case ('nom') { <p class="og__msg og__msg--er" role="alert"><lucide-angular [img]="icons.CircleX" [size]="24" /><span>No coinciden. Elige tu PIN de nuevo.</span></p> }
              @case ('facil') { <p class="og__msg og__msg--er" role="alert"><lucide-angular [img]="icons.CircleX" [size]="24" /><span>Ese PIN es muy fácil de adivinar. Elige otro.</span></p> }
              @case ('usado') { <p class="og__msg og__msg--er" role="alert"><lucide-angular [img]="icons.CircleX" [size]="24" /><span>Ese PIN no está disponible. Elige otro.</span></p> }
              @case ('sin-conexion') { <p class="og__msg og__msg--er" role="alert"><lucide-angular [img]="icons.WifiOff" [size]="24" /><span>Sin conexión. Conéctate e inténtalo de nuevo.</span></p> }
              @case ('fallo') { <p class="og__msg og__msg--er" role="alert"><lucide-angular [img]="icons.CircleX" [size]="24" /><span>No pudimos guardar tu PIN. Prueba otra vez.</span></p> }
              @default {
                @if (guardando()) {
                  <p class="og__msg og__msg--nt"><lucide-angular [img]="icons.Loader" [size]="24" /><span>Guardando tu PIN…</span></p>
                } @else if (paso() === 1) {
                  <p class="og__tip"><lucide-angular [img]="icons.Lightbulb" [size]="20" />No uses tu fecha de nacimiento.</p>
                }
              }
            }
          </div>
        </div>
        <div class="og__der">
          <sr-pin-keypad [deshabilitado]="teclasApagadas()" [activa]="teclaActiva()" (digito)="poner($event)" (borrar)="borrar()" />
        </div>
      }

      @case ('exito') {
        <div class="og__centro">
          <ng-container *ngTemplateOutlet="marca" />
          <div class="og__grande" aria-hidden="true"><lucide-angular [img]="icons.Check" [size]="56" /></div>
          <h1 id="og-titulo" class="og__h1">Listo. Este es tu PIN.</h1>
          <p class="og__sub">Desde ahora entras con él. No se muestra en ninguna parte.</p>
        </div>
        <div class="og__der og__der--col">
          <div class="og__acciones">
            <button type="button" class="og__btn og__btn--pri" (click)="seguir()">
              <lucide-angular [img]="icons.ArrowRight" [size]="26" />Seguir a mi trabajo
            </button>
          </div>
        </div>
      }
    }
    <p class="og__powered">Powered by <strong>SoftRent</strong></p>
  </div>
}

@if (operador.avisoDeBloqueo() && pantalla() === null) {
  <div class="og-aviso" role="alert">
    <lucide-angular [img]="icons.LockKeyhole" [size]="30" />
    <div><b>La tablet se va a bloquear</b><span>Toca para seguir sin volver a poner tu PIN.</span></div>
    <button type="button" class="og-aviso__btn" (click)="seguirTrabajando()">Seguir trabajando</button>
  </div>
}
